import ExperiencePage from "./ExperiencePage";
import { IMG } from "../../i18n/marketingImages";

export default function ExperienceCoastline() {
  return <ExperiencePage expKey="coastline" image={IMG.coastline2} />;
}
